<template>
  <v-dialog
    :value="show"
    @input="$emit('update:show', $event)"
    max-width="500"
    persistent
  >
    <v-card rounded="lg">
      <v-card-title class="subtitle-1 font-weight-bold pb-1">
        <v-icon color="teal" class="mr-2" small
          >mdi-package-variant-closed</v-icon
        >
        Add Bundle
      </v-card-title>
      <v-card-text class="pt-4">
        <v-text-field
          v-model="bundleName"
          label="Bundle Name"
          placeholder="e.g. Desktop PC Unit 1"
          outlined
          dense
          autofocus
          prepend-inner-icon="mdi-label"
        ></v-text-field>

        <v-combobox
          v-model="bundleType"
          :items="bundleTypes"
          label="Bundle Type"
          placeholder="Select or type a category"
          outlined
          dense
          prepend-inner-icon="mdi-shape"
        ></v-combobox>

        <v-divider class="my-3"></v-divider>

        <div class="caption grey--text text--darken-1 mb-2">
          Optionally load items from a saved template:
        </div>

        <v-autocomplete
          v-model="selectedTemplate"
          :items="templates"
          item-text="name"
          item-value="id"
          return-object
          label="Load from Template"
          placeholder="Search templates..."
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-file-document-outline"
          no-data-text="No templates saved yet"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ item.bundle_type }} - {{ (item.items || []).length }} items
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn text class="text-none" @click="close">Cancel</v-btn>
        <v-btn
          color="teal"
          depressed
          dark
          class="text-none"
          :disabled="!bundleName.trim()"
          @click="create"
        >
          <v-icon left small>{{
            selectedTemplate ? "mdi-file-document-outline" : "mdi-plus"
          }}</v-icon>
          {{ selectedTemplate ? "Load Template" : "Create Empty" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bundleName: "",
      bundleType: "Desktop PC",
      selectedTemplate: null,
      bundleTypes: [
        "Desktop PC",
        "Laptop Setup",
        "Network Kit",
        "CCTV Package",
        "Server Setup",
        "Custom",
      ],
    };
  },
  computed: {
    ...mapGetters({
      templates: "bundle_template/bundle_templates",
    }),
  },
  watch: {
    show(val) {
      if (val) {
        this.fetchTemplates();
        this.bundleName = "";
        this.bundleType = "Desktop PC";
        this.selectedTemplate = null;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchTemplates: "bundle_template/get_bundle_templates",
    }),
    close() {
      this.$emit("update:show", false);
    },
    create() {
      this.$emit("create", {
        name: this.bundleName.trim(),
        type: this.bundleType || "Custom",
        template: this.selectedTemplate || null,
      });
      this.close();
    },
  },
};
</script>
